import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgCart32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M24.032 28h-16c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h3.1a5 5 0 0 1 9.8 0h3.1c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2m-8-23c-1.86 0-3.43 1.27-3.87 3h7.75c-.44-1.73-2.01-3-3.87-3zm9 5c0-.55-.45-1-1-1h-3v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V9h-8v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V9h-3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h16c.55 0 1-.45 1-1z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgCart32);
export default Memo;